import { render, staticRenderFns } from "./AddLocationGrades.vue?vue&type=template&id=36dde42a&"
import script from "./AddLocationGrades.vue?vue&type=script&lang=js&"
export * from "./AddLocationGrades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports